
export var tab = 9;
export var enter = 13;
export var escape = 27;
export var space = 32;
export var pageUp = 33;
export var pageDown = 34;
export var end = 35;
export var home = 36;
export var arrowLeft = 37;
export var arrowUp = 38;
export var arrowRight = 39;
export var arrowDown = 40;


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/esm/view/key-codes.js
// module id = 282
// module chunks = 0